<div
  class="sidebar-area bg-white box-shadow"
  [ngClass]="{ active: isToggled }"
  [class.dark-sidebar]="themeService.isSidebarDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
>
  <div class="logo bg-white">
    <a
      [routerLink]="'/'"
      class="d-flex align-items-center justify-content-center"
    >
      <img class="logo-img" src="assets/img/etqra.svg" alt="logo" />
    </a>
  </div>
  <div class="burger-menu" (click)="toggle()" [ngClass]="{ active: isToggled }">
    <span class="top-bar"></span>
    <span class="middle-bar"></span>
    <span class="bottom-bar"></span>
  </div>
  <ng-scrollbar visibility="hover" style="height: 100vh">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>
          <ng-container>
            @if(userType === 'Staff' || userType == '0'){
            <a
              [routerLink]="ROUTES.DASHBOARD"
              class="sidebar-menu-link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMenuOnMobile()"
            >
              <i class="flatonCampuicon-menu-1"></i>
              <span class="title">{{
                "dashboard.capitalize" | translate
              }}</span>
            </a>
            }
          </ng-container>

          <ng-container>
            @if(userType === 'Assessor' || userType == '4'){
            <a
              [routerLink]="['/assessments/assessor-calendar']"
              class="sidebar-menu-link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMenuOnMobile()"
            >
              <i class="ri ri-calendar-line"></i>
              <span class="title">{{ "calendar.capitalize" | translate }}</span>
            </a>
            }
          </ng-container>

          @if(isLoading) {
          <ngx-skeleton-loader
            *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
            [theme]="{
              height: '50px',
              'margin-bottom': '10px',
              'background-color': '#f3f3f3'
            }"
          >
          </ngx-skeleton-loader>
          } @else { @for(item of sideBarItems; track $index){
          @if(item.displayFor.includes(userType)){
          <mat-expansion-panel
            class="mat-elevation-z0"
            expanded="true"
            [class.active]="router.isActive(item.active, false)"
            *ngIf="item?.permitted"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i [class]="item.icon"></i>
                <span class="title">{{ item.title | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if(item.items){
            <ul class="sidebar-sub-menu">
              @for(subItem of item.items; track $index){
              <li *ngIf="subItem.permitted" class="sidemenu-item">
                <a
                  [routerLink]="subItem.routerLink"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                  (click)="closeMenuOnMobile()"
                >
                  <i [class]="subItem.icon"></i>
                  {{ subItem.title | translate }}
                </a>
              </li>
              }
            </ul>
            }
          </mat-expansion-panel>
          } } }
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>
<!-- <a [routerLink]="ROUTES.ACADEMIC_PERSONNEL" class="sidebar-menu-link" routerLinkActive="active"
            [class.active]="
              router.isActive('/profile/academic-personnel', false)
            " [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenuOnMobile()">
            <i class="flaticon-user"></i>
            <span class="title">{{ "profile.capitalize" | translate }}</span>
          </a> -->
